export default __webpack_public_path__ + "static/media/clean-water.c84b1411.png";